module.exports = __webpack_public_path__ + "img/live-state-icon-active.4247b75.png";